export const FONTS = {
    display: '"DM Sans", sans-serif',
    body: '"Inter", sans-serif',
    // Editorial serif — reserved for hero "money" figures in Analytics, so
    // earnings read like a premium statement rather than a dashboard metric.
    serif: '"Fraunces", Georgia, serif',
} as const;

export const CARD_STYLES = {
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
    borderRadius: "16px",
    bgcolor: "white",
    p: 2,
} as const;

export const GLASS_SX = {
    bgcolor: "rgba(255,255,255,0.18)",
    backdropFilter: "blur(16px)",
    WebkitBackdropFilter: "blur(16px)",
    border: "1px solid rgba(255,255,255,0.3)",
} as const;

export const FORM_LABEL_SX = {
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    color: "text.secondary",
} as const;
